<template>
  <GenericLayout
    :title="$t('EVALUATE.POST.TITLE')"
    class="form py-4 fill-height"
    @close="$track('close_evaluation', 'evaluation')"
  >
    <div class="form-container">
      <FormPostWelcome
        v-if="preform"
        @next="startForm"
      />

      <FormPost v-else />
    </div>
  </GenericLayout>
</template>

<style scoped lang="scss">
.form {
  background-color: $grey-bg;
}

.form-container {
  max-width: 500px;
  margin: 0 auto;
}
</style>

<script>
import GenericLayout from '@/layouts/GenericLayout.vue';
import FormPostWelcome from '@/components/form/FormPostWelcome.vue';
import FormPost from '@/components/form/FormPost.vue';

export default {
  name: 'Form',
  components: {
    GenericLayout,
    FormPostWelcome,
    FormPost,
  },
  data: () => ({
    preform: true,
  }),
  methods: {
    startForm() {
      this.preform = false;
    },
  },
};
</script>
